(() => {
  if (window.__BUGA_WISHLIST_INITIALIZED__) return;
  window.__BUGA_WISHLIST_INITIALIZED__ = true;

  const STORAGE_KEY = 'buga:wishlist:v1';

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item) => item && item.id && item.title && item.url);
    } catch (_error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('buga:wishlist:change', { detail: { items } }));
  };

  const safeProductUrl = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? `${url.pathname}${url.search}${url.hash}` : '/collections/all';
    } catch (_error) {
      return '/collections/all';
    }
  };

  const safeImageUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (_error) {
      return '';
    }
  };

  const itemFromButton = (button) => ({
    id: String(button.dataset.productId || ''),
    title: String(button.dataset.productTitle || '').trim(),
    url: safeProductUrl(button.dataset.productUrl || ''),
    price: String(button.dataset.productPrice || '').trim(),
    image: safeImageUrl(button.dataset.productImage || ''),
  });

  const syncToggleButtons = (items = readWishlist()) => {
    const savedIds = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('[data-buga-wishlist-toggle]').forEach((button) => {
      const active = savedIds.has(String(button.dataset.productId || ''));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const title = button.dataset.productTitle || 'this product';
      button.setAttribute('aria-label', active ? `Remove ${title} from favorites` : `Add ${title} to favorites`);
    });

    document.querySelectorAll('[data-buga-wishlist-count]').forEach((counter) => {
      counter.textContent = String(items.length);
      counter.hidden = items.length === 0;
    });
  };

  const createSvgHeart = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.6');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(path);
    return svg;
  };

  const renderWishlistPage = (items = readWishlist()) => {
    const root = document.querySelector('[data-buga-wishlist-page]');
    if (!root) return;

    const grid = root.querySelector('[data-buga-wishlist-grid]');
    const empty = root.querySelector('[data-buga-wishlist-empty]');
    const count = root.querySelector('[data-buga-wishlist-page-count]');
    if (!grid || !empty || !count) return;

    count.textContent = `${items.length} ${items.length === 1 ? 'ITEM' : 'ITEMS'}`;
    empty.hidden = items.length !== 0;
    grid.hidden = items.length === 0;
    grid.replaceChildren();

    items.forEach((item) => {
      const article = document.createElement('article');
      article.className = 'buga-wishlist-card';

      const media = document.createElement('a');
      media.className = 'buga-wishlist-card__media';
      media.href = safeProductUrl(item.url);
      media.setAttribute('aria-label', item.title);

      if (item.image) {
        const image = document.createElement('img');
        image.src = safeImageUrl(item.image);
        image.alt = item.title;
        image.loading = 'lazy';
        image.decoding = 'async';
        media.appendChild(image);
      } else {
        const placeholder = document.createElement('div');
        placeholder.className = 'buga-wishlist-card__placeholder';
        placeholder.textContent = 'BUGA';
        media.appendChild(placeholder);
      }

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'buga-wishlist-card__remove';
      remove.dataset.bugaWishlistRemove = String(item.id);
      remove.setAttribute('aria-label', `Remove ${item.title} from favorites`);
      remove.appendChild(createSvgHeart());

      const info = document.createElement('div');
      info.className = 'buga-wishlist-card__info';

      const title = document.createElement('h2');
      title.className = 'buga-wishlist-card__title';
      title.textContent = item.title;

      const price = document.createElement('p');
      price.className = 'buga-wishlist-card__price';
      price.textContent = item.price || '';

      const link = document.createElement('a');
      link.className = 'buga-wishlist-card__link';
      link.href = safeProductUrl(item.url);
      link.textContent = 'VIEW PRODUCT';

      info.append(title, price, link);
      article.append(media, remove, info);
      grid.appendChild(article);
    });
  };

  const syncAll = () => {
    const items = readWishlist();
    syncToggleButtons(items);
    renderWishlistPage(items);
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-buga-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      const item = itemFromButton(toggle);
      if (!item.id || !item.title) return;

      const items = readWishlist();
      const index = items.findIndex((saved) => String(saved.id) === item.id);
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift(item);
      }
      writeWishlist(items);
      return;
    }

    const remove = event.target.closest('[data-buga-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      const id = String(remove.dataset.bugaWishlistRemove || '');
      writeWishlist(readWishlist().filter((item) => String(item.id) !== id));
    }
  });

  window.addEventListener('buga:wishlist:change', (event) => {
    const items = event.detail?.items || readWishlist();
    syncToggleButtons(items);
    renderWishlistPage(items);
  });

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) syncAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll, { once: true });
  } else {
    syncAll();
  }

  let observerQueued = false;
  const observer = new MutationObserver(() => {
    if (observerQueued) return;
    observerQueued = true;
    requestAnimationFrame(() => {
      observerQueued = false;
      syncToggleButtons();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
